import { render, staticRenderFns } from "./uni-icon.vue?vue&type=template&id=238362e2&"
import script from "./uni-icon.vue?vue&type=script&lang=js&"
export * from "./uni-icon.vue?vue&type=script&lang=js&"
import style0 from "./uni-icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238362e2')) {
      api.createRecord('238362e2', component.options)
    } else {
      api.reload('238362e2', component.options)
    }
    module.hot.accept("./uni-icon.vue?vue&type=template&id=238362e2&", function () {
      api.rerender('238362e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uni-icon/uni-icon.vue"
export default component.exports